import React from "react";

const PremiumIconSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7668_13359)">
        <path
          d="M8.5632 2.12669C9.25076 1.109 10.7492 1.109 11.4368 2.12669C11.8819 2.78552 12.7181 3.05721 13.4654 2.78583C14.6198 2.36664 15.8321 3.24743 15.7902 4.47489C15.7631 5.26952 16.2798 5.9808 17.044 6.20054C18.2243 6.53996 18.6874 7.9651 17.932 8.93349C17.4429 9.5604 17.4429 10.4396 17.932 11.0665C18.6874 12.0349 18.2243 13.46 17.044 13.7995C16.2798 14.0192 15.7631 14.7305 15.7902 15.5251C15.8321 16.7526 14.6198 17.6334 13.4654 17.2142C12.7181 16.9428 11.8819 17.2145 11.4368 17.8733C10.7492 18.891 9.25076 18.891 8.5632 17.8733C8.11809 17.2145 7.28193 16.9428 6.53458 17.2142C5.38015 17.6334 4.16785 16.7526 4.20979 15.5251C4.23694 14.7305 3.72017 14.0192 2.95603 13.7995C1.77569 13.46 1.31263 12.0349 2.06804 11.0665C2.55708 10.4396 2.55708 9.5604 2.06804 8.93349C1.31263 7.9651 1.77569 6.53996 2.95603 6.20054C3.72017 5.9808 4.23694 5.26952 4.20979 4.47489C4.16785 3.24743 5.38015 2.36664 6.53458 2.78583C7.28193 3.05721 8.11809 2.78552 8.5632 2.12669Z"
          fill="#CCFF00"
        />
        <path
          d="M14.3082 12.6253L14.1158 13.4597C14.0764 13.63 13.9249 13.7503 13.7502 13.7503H6.2502C6.07545 13.7503 5.92395 13.63 5.88457 13.4597L5.6922 12.6253H14.3082ZM15.2408 8.58472L14.4814 11.8753H5.51895L4.75957 8.58472C4.7262 8.4396 4.7817 8.2881 4.90132 8.19922C5.02132 8.11035 5.1822 8.10097 5.3112 8.17485L7.63207 9.50122L9.68782 6.4176C9.75495 6.3171 9.86595 6.25485 9.98632 6.25035C10.1078 6.2451 10.2222 6.29985 10.2961 6.3951L12.7069 9.49485L14.6671 8.18835C14.7949 8.1036 14.9618 8.10435 15.0882 8.19172C15.2149 8.2791 15.2749 8.4351 15.2408 8.58472Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_7668_13359">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PremiumIconSvg;
